import * as z from 'zod';

import { AttachmentSchema } from './common/attachment';

export const DirectionFacingSchema = z.enum(
  ['N', 'E', 'W', 'S', 'NE', 'NW', 'SE', 'SW'],
  { error: 'Direction Facing is required' },
);
export type DirectionFacing = z.infer<typeof DirectionFacingSchema>;

export const OperabilitySchema = z.enum(['operable', 'fixed']);
export type Operability = z.infer<typeof OperabilitySchema>;

export const FrameMaterialSchema = z.enum(['aluminum', 'wood', 'vinyl']);
export type FrameMaterial = z.infer<typeof FrameMaterialSchema>;

export const AuditWindowsFormEntrySchema = z.object({
  section: z
    .string({ error: 'Section is required' })
    .nonempty({ error: 'Section is required' }),
  directionFacing: DirectionFacingSchema,
  quantity: z.coerce.number().optional(),
  isUsingMetrics: z.boolean(),
  widthInFeet: z.coerce.number().optional(),
  widthInInches: z.coerce.number().optional(),
  heightInFeet: z.coerce.number().optional(),
  heightInInches: z.coerce.number().optional(),
  widthInMeters: z.coerce.number().optional(),
  heightInMeters: z.coerce.number().optional(),
  area: z.coerce.number().optional(),
  operability: OperabilitySchema.optional(),
  frameMaterial: FrameMaterialSchema.optional(),
  glazingPanes: z.coerce.number().optional(),
  notes: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});
export type AuditWindowsFormEntry = z.infer<typeof AuditWindowsFormEntrySchema>;

export const AuditWindowsFormSchema = z.object({
  type: z.literal('windows'),
  entries: z.array(AuditWindowsFormEntrySchema),
});
export type AuditWindowsForm = z.infer<typeof AuditWindowsFormSchema>;
